import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleProfileHeaderComponent } from './people-profile-header.component';
import { AvatarIconModule } from "../../components/avatar-icon/avatar-icon.module";
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { ButtonModule } from '@xref/xref-lib';
@NgModule({
  declarations: [PeopleProfileHeaderComponent],
  imports: [
    CommonModule,
    AvatarIconModule,
    RouterModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    ButtonModule,
  ],
  exports: [
    PeopleProfileHeaderComponent
  ]
})
export class PeopleProfileHeaderModule { }
